import React from 'react';
import { Card } from "react-bootstrap";
import faceLaszloMolnar from "../../assets/img/faceLaszloMolnar.jpg";
import ShowMoreText from "react-show-more-text";
import projMolnarL_videogame from "../../assets/img/projMolnarL_videogame.png";

const Laszlo_Molnar_videogame = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projMolnarL_videogame} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={faceLaszloMolnar}
            />{" "}
            <p className="text7">László Molnár</p>
            <br />
            <p className="text8">
              Research Assistant{" "}
            </p>
            <p className="text8">Department of Management and Business Economics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The video game industry is part of the so-called hedonistic sectors, where rapid innovation and consumer preferences shape 
            market outcomes. Business model innovation (BMI) plays a crucial role in the success of both indie developers and AAA 
            publishers. This project aims to collect and analyse data to formalize the dynamics of BMI adoption in the video game 
            ecosystem using quantitative models. Possible approaches include diffusion models (e.g., Bass-type), agent-based modeling to 
            simulate developer–consumer interactions, and econometric analysis based on market data. 
            <br />
            The key research question is: 
            <br />
            <i>How do new business models (e.g., subscription, free-to-play, live-service) spread in the industry, and what factors 
                influence their success or failure?</i>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Molnar_videogame;